import InfluencerCardHeader from 'Components/influencer/InfluencerCardHeader'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { Input, Modal } from 'reactstrap'
import { addCollaborationPayment } from 'services/api/campaign/collaboration'
import { RootState } from 'store'
import { Collaboration } from 'types/campaign/collaborations'
import { getErrorMessage } from 'utils/helpers'

const AddCollabPayment: React.FC<{ campaignId: string, collaobration?: Collaboration | null, isOpen: boolean, onClose: () => void, onSuccess: (amount: number) => void }> = ({ campaignId, collaobration, isOpen, onClose, onSuccess }) => {
    const [amount, setAmount] = useState('');
    const selectedAgencyId = useSelector((state: RootState) => state.auth.selectedAgencyId);
    const [processing, setProcessing] = useState(false);

    useEffect(() => {
        if (collaobration) {
            setAmount('');
        }
    }, [isOpen, collaobration])

    const addPayment = async () => {
        if (!selectedAgencyId || !campaignId || !collaobration?.uuid || Number(amount) === 0) return;

        try {
            setProcessing(true);
            await addCollaborationPayment(selectedAgencyId, campaignId, collaobration.uuid, Number(amount));
            toast.success("Payment added!");
            onSuccess(Number(amount))
            onClose();
        } catch (error) {
            console.log('err', error);
            toast.error(getErrorMessage(error));
        } finally {
            setProcessing(false);
        }
    }

    return (
        <Modal isOpen={isOpen} toggle={onClose} centered className='application-cost-approval-modal' >
            <div className="modal-body">
                <h6 className='application-cost-approval-modal-title mb-1'>Track CPV and CPE</h6>
                <div className='mb-3'><span>Add the payment made to this creator to track CPV and CPE.</span></div>
                <InfluencerCardHeader
                    name={collaobration?.influencer?.name ?? (collaobration?.social_account?.name ?? `@${collaobration?.social_account?.handle}`)}
                    padding='p-0'
                    hideAdditionalInfo={true}
                    borderBottom={false}
                    socialAccount={collaobration?.social_account}
                />
                <div className='mt-3'>
                    <Input type='number' placeholder='Enter amount paid to this creator' value={amount} onChange={(e) => setAmount(e.target.value)} />

                </div>
                <div className="mt-4 d-flex justify-content-between align-items-center gap-4">
                    <button className="btn btn-gradient-outline w-50" onClick={onClose}>Cancel</button>
                    <button onClick={addPayment} className="btn btn-gradient w-50" disabled={!Number(amount) || processing}>{processing ? 'Calculating...' : 'Calculate CPV & CPE'}</button>
                </div>
            </div>
        </Modal >
    )
}

export default AddCollabPayment
